import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./ShowSalonImages.css"

function ShowSalonImages({ salonImages }) {
    const settings = {
        dots: true,
        infinite: salonImages.length > 1, // Only loop if there is more than one image
        speed: 500,
        slidesToShow: Math.min(3, salonImages.length), // Ensure it doesn't show more slides than available images
        slidesToScroll: 1,
        autoplay: salonImages.length > 1, // Only autoplay if there are multiple images
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 768,
                settings: { slidesToShow: Math.min(2, salonImages.length) }
            },
            {
                breakpoint: 480,
                settings: { slidesToShow: 1 }
            }
        ]
    };

    return (
        <div className="carousel-container">
            <Slider {...settings}>
                {salonImages.map((emp, index) => (
                    <div key={"si_" + index} className="carousel-item">
                        <img src={`data:image/jpeg;base64,${emp}`} alt={`Salon ${index + 1}`} className="carousel-image" />
                    </div>
                ))}
            </Slider>
        </div>
    );
}

export default ShowSalonImages;
